// extracted by mini-css-extract-plugin
export var cartContainer = "_ml-4";
export var gray = "_ml-1";
export var itemContainer = "_ml-2";
export var itemDetails = "_ml-3";
export var strong = "_ml-0";